import AgentSignup from './components/AgentSignup';
import './App.css';

function App() {
  return <AgentSignup />;
}

export default App;